const clamp = function(a: number, min: number, max: number): number {
  if (a < min) {
    return min;
  } else if (a > max) {
    return max;
  }
  return a;
};

export default clamp;
